export default "__VITE_ASSET__4lc$HXm6__"